import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../units/Modal/Modal';
import FormWrapper from './FormWrapper/FormWrapper';
import FormsActions from '../../../store/forms/formsActions';
import FormsConfigs from '../../../store/forms/formsConfigs/formsConfigs';

// TODO: auto width for modals
class ModalForm extends Component {
  static propTypes = {
    form: PropTypes.object.isRequired
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.form !== this.props.form;
  }

  getModalWidth = (form, formConfig) => {
    return typeof formConfig.modalWidth === 'function'
      ? formConfig.modalWidth(form)
      : formConfig.modalWidth;
  };

  getModalHeight = (form, formConfig) => {
    return typeof formConfig.modalHeight === 'function'
      ? formConfig.modalHeight(form)
      : formConfig.modalHeight;
  };

  getModalPadding = (form, formConfig) => {
    return typeof formConfig.modalPadding === 'function'
      ? formConfig.modalPadding(form)
      : formConfig.modalPadding;
  };

  render() {
    const { form } = this.props;
    const config = FormsConfigs.getByName(form.id);

    if (!config) return null;

    const onClose = config.title
      ? () => {
          FormsActions.apply({
            instanceName: form.instanceName,
            instanceToken: form.instanceToken,
            actionId: '_close'
          });
        }
      : null;
    return (
      <Modal
        key={form.formId}
        active
        title={config.title}
        width={this.getModalWidth(form, config)}
        contentWidth={config.modalContentWidth}
        height={this.getModalHeight(form, config)}
        maxHeight={config.modalMaxHeight}
        padding={this.getModalPadding(form, config)}
        className={config.modalClassName}
        onClose={onClose}
      >
        <FormWrapper {...form} config={config} />
      </Modal>
    );
  }
}

export default ModalForm;



// WEBPACK FOOTER //
// ./src/components/containers/Forms/ModalForm.js